import React, { Component } from "react";
import { Card, ButtonGroup, Button, Icon } from "@blueprintjs/core";
import DesignPreview from "../DesignPreview";
import { withAuthentication } from "../Session";
import { withRouter, Link, RouteComponentProps } from "react-router-dom";
import styled from "styled-components";

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  display: flex;
  align-items: flex-end;
  transition: 0.2s;
`;

const OwnerIcon = styled.div`
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  width: 2em;
  height: 2em;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #4580E6;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(hsla(0, 0%, 100%, 0.1)),
    to(hsla(0, 0%, 100%, 0))
  );
  background-image: linear-gradient(
    180deg,
    hsla(0, 0%, 100%, 0.1),
    hsla(0, 0%, 100%, 0)
  );
  color: #fff;
  box-shadow: 0 0 0 1px rgba(16,22,26,.4);
`;

const ApprovedIcon = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 2em;
  height: 2em;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #43BF4D;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(hsla(0, 0%, 100%, 0.1)),
    to(hsla(0, 0%, 100%, 0))
  );
  background-image: linear-gradient(
    180deg,
    hsla(0, 0%, 100%, 0.1),
    hsla(0, 0%, 100%, 0)
  );
  color: #fff;
  box-shadow: 0 0 0 1px rgba(16,22,26,.4);
`;

const DesignWrapper = styled.div`
  position: relative;
  margin: -20px;
  border-radius: 3px;
  overflow: hidden;
  width: 192px;
  height: 192px;
  & > ${Overlay} {
    opacity: 0;
  }
  &:hover {
    & > ${Overlay} {
      opacity: 1;
    }
  }
`;

const Title = styled.div`
  color: #fff;
  font-size: 1.777em;
  font-weight: 500;
  margin-bottom: 0.5rem;
`;

interface Props {
  design: {
    id: string;
    data: string;
    title: string;
    user: string;
    code?: string;
    approved?: boolean;
  };
  authUser: {
    uid: string;
  };
  link: string;
}

const GalleryCard: React.SFC<Props> = ({ design, authUser, link }) => {
  const owner = authUser && design.user === authUser.uid;
  return (
    <Link to={link}>
      <Card interactive style={{ width: "192px", height: "192px" }}>
        <DesignWrapper>
          <DesignPreview data={design.data} />
          {design.approved && (
            <ApprovedIcon>
              <Icon icon="play" color="#fff" />
            </ApprovedIcon>
          )}
          {owner && (
            <OwnerIcon>
              <Icon icon="edit" color="#fff" />
            </OwnerIcon>
          )}
          <Overlay>
            <div style={{ width: "100%" }}>
              <Title>{design.title}</Title>
              <ButtonGroup fill>
                <Button intent="primary">{owner ? "Edit" : "View"}</Button>
              </ButtonGroup>
            </div>
          </Overlay>
        </DesignWrapper>
      </Card>
    </Link>
  );
};

export default withAuthentication(GalleryCard);
